import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { useCategoryFeatures } from "../../../hooks/useCategoryFeatures"; // Adjust path as needed

const MechanicalCourses = () => {
  const mechanicalFeatures = useCategoryFeatures("Mechanical");

  return (
    <div className="mt-6">
      <p className="text-xl text-primary text-center">Our Courses</p>
      <h2 className="text-3xl font-semibold text-primary text-center mt-4">
        One Platform Many Options To Explore
      </h2>
      <div className="py-6 px-4">
        <div className="container mx-auto flex flex-col items-center">
          {/* First Row: features[0], features[1], and features[2] side by side */}
          <div className="w-full flex flex-col sm:flex-row justify-center gap-6 mb-6">
            {mechanicalFeatures.slice(0, 3).map((feature) => (
              <Link
                to={feature.link}
                key={feature.id}
                className="flex-1 sm:max-w-[492px] w-full"
              >
                <div className="relative bg-white rounded-md p-8 text-center border border-gray-200 transition-all duration-300 hover:border-primary hover:border-3 group hover:rounded-tr-[60px]">
                  <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center rounded-full bg-gray-100 transition-all duration-300 group-hover:bg-primary">
                    <FontAwesomeIcon
                      icon={feature.icon}
                      className="text-primary text-3xl transition-all duration-300 group-hover:text-white"
                    />
                  </div>
                  <h3 className="text-xl font-medium">{feature.title}</h3>
                </div>
              </Link>
            ))}
          </div>

          {/* Grid for remaining items */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6 w-full">
            {mechanicalFeatures.slice(3).map((feature) => (
              <Link to={feature.link} key={feature.id}>
                <div className="relative bg-white rounded-md p-8 w-full text-center border border-gray-200 transition-all duration-300 hover:border-primary hover:border-3 group hover:rounded-tr-[60px]">
                  <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center rounded-full bg-gray-100 transition-all duration-300 group-hover:bg-primary">
                    <FontAwesomeIcon
                      icon={feature.icon}
                      className="text-primary text-3xl transition-all duration-300 group-hover:text-white"
                    />
                  </div>
                  <h3 className="text-xl font-medium">{feature.title}</h3>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MechanicalCourses;
